
import {getRolesPantalla} from '@/utils/funtionsGlobals';

export default [
  {
    path: '/MtoAvisosView',
    name: 'MtoAvisosView',
    component: () =>
      import('../views/configuracion/avisos/AvisosView.vue'),
    meta: {
      title: 'Buscador Avisos',
      requiresAuthentication: true,
      requiresAuthorization: false,
      roles: getRolesPantalla('MtoAvisosView'),
      bread: {
        path: [
          'Configuración',
        ],

      },
    },
  },
];
